import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=c062b0d8&scoped=true&"
import script from "./OutboundList.vue?vue&type=script&lang=js&"
export * from "./OutboundList.vue?vue&type=script&lang=js&"
import style0 from "./OutboundList.vue?vue&type=style&index=0&id=c062b0d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c062b0d8",
  null
  
)

export default component.exports